export function avatarImageUrl(image: string | null | undefined, size: 80 | 512) {
  if (!image) return undefined
  if (!image.startsWith('/api/avatars/')) return image
  return `${image}${image.includes('?') ? '&' : '?'}size=${size}`
}
